import { SET_BENEFICIARY_AUTH_TYPE,VERIFY_CHILD_FROM_GRID,UPDATE_FACILITY_SERVICE_DATA,SET_BENF_DEATH_DETAILS,SET_SHOW_PREGNANCY_ONGOING,SET_IS_PREGNANT,SET_SHOW_PREGNANCY,SET_SHOW_SERVICES,SET_IS_HRP,SET_CHECK_IS_HRP,SET_IS_FIRST_PREGNANCY ,SET_BENEFICIARY_GENDER,SET_LMP_DATE,SET_ANC_VISIT_DATE,SET_BENEFICIARY_REDG_OPTION,SET_BENEFICIARY_MOBILE_NUMBER,SET_TSNID,SET_AADHAR,SET_BENEFICIARY_DATA, SET_BENEFICIARY_ABHA, SET_SHOW_CLOSE_MODAL,SET_IS_BENEFICIARY_MODIFIED, UPDATE_CHILD,SET_BENEFICIARY_DETAILS,SET_BENF_ID,SET_IMAGE_EDITED,SET_IMAGE_DATA, UPDATE_ANCSERVICE,SET_ANC_NUMBER,SET_FACILITY_DETAILS, SET_PREGNANCY_ID,SET_DIFF_IN_WEEKS, SET_IS_VIEW_BUTTON_CLICKED,UPDATE_PREG_HANDLER, UPDATE_DELIVERY_DETAILS, UPDATE_PNC, UPDATE_FAMILY_PLANNING_BACK_HANDLER, SET_FAMILY_PLANNING_DETAILS, SET_CONSENT_LANGUAGE, SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID,UPDATE_FACILITY_META_DATA, UPDATE_CHILD_DETAILS, SET_BENEFICIARY_ALREADY_IN_RCH, SET_BENEFICIARIES_IN_RCH, SET_TXNID_FOR_ABHA_ADDRESS, SET_ABHA_ADDRESS, SET_PRIMARY_NO_FOR_RCH, SET_REFERRAL_MODULE, SET_LIFE_CALENDAR_PAGE_MENU, SET_PREGNANCY_HISTORY, SET_BENEFICIARY_PREGNANCY_HISTORY, SET_PREGNANCY_DETAILS, SET_HRP_STATUS, SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY,SET_BENEFICIARY_IMAGE, SET_CHILD_BENEF_LIST, SET_BENEFICIARY_OBSTETRIC_HISTORY} from "@store/types/beneficiaryTypes";

export const setBeneficiaryGender = (data: string) => {
  return {
    type: SET_BENEFICIARY_GENDER,
    payload: data
  };
};
 
export const setBeneficiaryRedgOption = (data: string) => {
  return {
    type: SET_BENEFICIARY_REDG_OPTION,
    payload: data
  };
};

 
export const setBeneficiaryAuthType = (data: string) => {
  return {
    type: SET_BENEFICIARY_AUTH_TYPE,
    payload: data
  };
};
export const setBeneficiaryMobileNumber = (data: string) => {
  return {
    type: SET_BENEFICIARY_MOBILE_NUMBER,
    payload: data
  };
};
export const setTsnID = (data: string) => {
  return {
    type: SET_TSNID,
    payload: data
  };
};

export const setTxnIdForAbhaAddress = (data: string) => {
  return {
    type: SET_TXNID_FOR_ABHA_ADDRESS,
    payload: data
  };
};
export const setAbhaAddress = (data: string) => {
  return {
    type: SET_ABHA_ADDRESS,
    payload: data
  };
};
export const setPrimaryNoForRCH = (data: string) => {
  return {
    type: SET_PRIMARY_NO_FOR_RCH,
    payload: data
  };
};
 
export const setAadhar = (data: string) => {
  return {
    type: SET_AADHAR,
    payload: data
  };
};

export const beneficiaryAlreadyInRCH = (data: boolean) => {
  return {
    type: SET_BENEFICIARY_ALREADY_IN_RCH,
    payload: data
  };
};

export const beneficiariesInRCH = (data: any) => {
  return {
    type: SET_BENEFICIARIES_IN_RCH,
    payload: data
  };
};

export const setIsHRP = (data: boolean) => {
  return {
    type: SET_IS_HRP,
    payload: data
  };
};
export const setCheckIsHrp = (data: boolean) => {
  return {
    type: SET_CHECK_IS_HRP,
    payload: data
  };
};
 
export const setBeneficiaryData = (data: any) => {
  return {
    type: SET_BENEFICIARY_DATA,
    payload: data
  };
};

export const setBeneficiaryAbha = (data: any) => {
  return {
    type: SET_BENEFICIARY_ABHA,
    payload: data
  };
};

export const updateChild = (field:string , value:any)=>({
  type:UPDATE_CHILD,
  payload:{field,value}
});

export const updateChildVerifyFromGrid = ( value:any)=>({
  type:VERIFY_CHILD_FROM_GRID,
  payload:value
});
export const showCloseModal = (data: any) => {
  return {
    type: SET_SHOW_CLOSE_MODAL,
    payload: data
  };
};
export const isBeneficiaryModified = (data: any) => {
  return {
    type: SET_IS_BENEFICIARY_MODIFIED,
    payload: data
  };
};
export const setBeneficiaryDetails = (data: any) => {
  return {
    type: SET_BENEFICIARY_DETAILS,
    payload: data
  };
}; 

export const setIsFirstPregnancy = (data: any) => {
  return {
    type: SET_IS_FIRST_PREGNANCY,
    payload: data
  };
};

export const setPregnancyHistory = (data: any) => {
  return {
    type: SET_PREGNANCY_HISTORY,
    payload: data
  };
};

export const setBenfId = (data: any) => {
  return {
    type: SET_BENF_ID,
    payload: data
  };
};

export const isImageEdited = (data: any) => {
  return {
    type: SET_IMAGE_EDITED,
    payload: data
  };
};
export const imageData = (data: any) => {
  return {
    type: SET_IMAGE_DATA,
    payload: data
  };
};
export const updateAncService = (field:string , value:any)=>({
  type:UPDATE_ANCSERVICE,
  payload:{field,value}
});

export const setAncNumber = ( value:any)=>({
  type:SET_ANC_NUMBER,
  payload:value
});

export const setANCVisitDate = ( value:any)=>({
  type:SET_ANC_VISIT_DATE,
  payload:value
});

export const setFacilityDetails = ( value:any)=>({
  type:SET_FACILITY_DETAILS,
  payload:value
});
export const setPregnancyId = ( value:any)=>({
  type:SET_PREGNANCY_ID ,
  payload:value
});

export const setShowPregnancy = ( value:any)=>({
  type:SET_SHOW_PREGNANCY,
  payload:value
});

export const setPregnancyOngoing = ( value:any)=>({
  type:SET_SHOW_PREGNANCY_ONGOING,
  payload:value
});

export const setShowServices = ( value:any)=>({
  type:SET_SHOW_SERVICES,
  payload:value
});

export const setLmpDate = ( value:any)=>({
  type:SET_LMP_DATE,
  payload:value
});


export const setdiffInWeeks = ( value:any)=>({
  type:SET_DIFF_IN_WEEKS,
  payload:value
});
export const setIsViewButtonClicked = ( value:any)=>({
  type:SET_IS_VIEW_BUTTON_CLICKED,
  payload:value
});

export const setAncPregBackHandler = ( value:any)=>({
  type:UPDATE_PREG_HANDLER,
  payload:value
});

export const setFamilyPlanningBackHandler = ( value:any)=>({
  type:UPDATE_FAMILY_PLANNING_BACK_HANDLER,
  payload:value
});

export const setFamilyPlanningDetails =(value:any)=>({
  type:SET_FAMILY_PLANNING_DETAILS,
  payload:value
})

export const setFamilyPlanningDetailsByTransactionId =(value:any)=>({
  type:SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID,
  payload:value
})

export const updateDeliveryDetails = (field:string , value:any)=>({
  type:UPDATE_DELIVERY_DETAILS,
  payload:{field,value}
});

export const updatePNC = (field:string , value:any)=>({
  type:UPDATE_PNC,
  payload:{field,value}
});
export const setConsentLanguage = ( value:any)=>({
  type:SET_CONSENT_LANGUAGE,
  payload:value
});

export const setFacilityMetaData = ( value:any)=>({
  type:UPDATE_FACILITY_META_DATA,
  payload:value
}); 

export const setFacilityServiceData = ( value:any)=>({
  type:UPDATE_FACILITY_SERVICE_DATA,
  payload:value
}); 

export const setIsPregnant = ( value:any)=>({
  type:SET_IS_PREGNANT,
  payload:value
});


export const setBenfDeathDetails = ( value:any)=>({
  type:SET_BENF_DEATH_DETAILS,
  payload:value
});

export const updateChildDetails = ( value:any)=>({
  type:UPDATE_CHILD_DETAILS,
  payload:value
});

export const setReferralModule = (field:string , value:any)=>({
  type:SET_REFERRAL_MODULE,
  payload:{field,value}
});


export const setLifeCalendarPageMenu = (data: any) => {
  return {
    type: SET_LIFE_CALENDAR_PAGE_MENU,
    payload: data
  };
};

export const setLifeCalendarPagePreviousPragnancy = (data: any) => {
  return {
    type: SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY,
    payload: data
  };
};
export const setBeneficiaryPregnancyHistory = (data: any) => {
  return {
    type: SET_BENEFICIARY_PREGNANCY_HISTORY,
    payload: data
  };
};
export const setPregnancyDetails = (data: any) => {
  return {
    type: SET_PREGNANCY_DETAILS,
    payload: data
  };
};
export const setHrpStatus = (data: any) => {
  return {
    type: SET_HRP_STATUS,
    payload: data
  };
};
export const setBeneficiaryImage = (data: any) => {
  return {
    type: SET_BENEFICIARY_IMAGE,
    payload: data
  };
};
export const setChildBenefList = ( value:any)=>({
  type:SET_CHILD_BENEF_LIST,
  payload:value
});
export const setBeneficiaryObstetricHistory = ( value:any)=>({
  type:SET_BENEFICIARY_OBSTETRIC_HISTORY,
  payload:value
});
